  export function getInvoiceId(factura) {
    if (typeof factura !== "string") return '';

    const parts = factura.split(':');

    // Buscar índice de "id" y "valor"
    const idxId = parts.indexOf('id');
    const idxValor = parts.indexOf('valor');

    if (idxId === -1 || idxValor === -1) return '';

    // Contar cuántos valores hay entre "id" y "valor"
    const ids = parts.slice(idxId + 1, idxValor);
    const valores = parts.slice(idxValor + 1);

    // Solo devolver si hay exactamente 1 ID y 1 valor
    if (ids.length === 1 && valores.length === 1) {
      return ids[0];
    }

    return '';
  }